(ns frontend.test.mention-editor.view
  (:require
   [frontend.components.field-editor :as field-editor]
   [reagent.core :as r]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.view.page.view :as page]))

(defonce labelled-state* (r/atom {:subject "Hello {{target}}"
                                  :body    "<p>Please complete before {{reference_date}}</p>"}))

(defonce field-editor-state* (r/atom {:test/subject "Hello {{target}}"
                                      :test/body    "<p>Please complete before {{reference_date}}</p>"}))

(defn- section
  [title body]
  [:section {:class "flex flex-col gap-3 rounded-lg border border-solid border-base-light-border-paler bg-base-lightest p-4"}
   [:h2 {:class "text-lg font-semibold"} title]
   body])

(defn- labelled-input-demo
  []
  [section
   "Labelled input + data-input path"
   [:div {:class "flex flex-col gap-4"}
    [labelled-input/view
     {:label              "Subject mention editor"
      :editor-type        :editor.type/text-mention
      :data-type          :data.type/text-simple
      :ui/variable-source :survey-template-text
      :value              (:subject @labelled-state*)
      :on-change          (fn [value]
                            (swap! labelled-state* assoc :subject value))}]
    [labelled-input/view
     {:label              "Body mention editor"
      :editor-type        :editor.type/richtext-mention
      :data-type          :data.type/text-richtext
      :ui/variable-source :survey-template-text
      :value              (:body @labelled-state*)
      :on-change          (fn [value]
                            (swap! labelled-state* assoc :body value))}]
    [:pre {:class "rounded bg-base-light p-3 text-xs overflow-auto"}
     (pr-str @labelled-state*)]]])

(defn- field-editor-demo
  []
  (let [errors* (r/atom {})]
    (fn []
      [section
       "frontend.components.field-editor path"
       [:div {:class "flex flex-col gap-4"}
        [field-editor/view
         {:id           "mention-field-editor-subject"
          :attribute    :test/subject
          :label        "Subject via field-editor"
          :state-atom   field-editor-state*
          :value        (:test/subject @field-editor-state*)
          :editor/type  :editor.type/text-mention
          :field/data-type :data.type/text-simple
          :ui/variable-source :survey-template-text
          :tools        [:tool-item/clear :tool-item/save :tool-item/cancel]
          :error-text   (get @errors* :test/subject)
          :validate!    (fn [_attribute _value] nil)
          :on-save!     (fn [attribute value on-success! _on-error!]
                          (swap! field-editor-state* assoc attribute value)
                          (on-success!))}]
        [field-editor/view
         {:id              "mention-field-editor-body"
          :attribute       :test/body
          :label           "Body via field-editor"
          :state-atom      field-editor-state*
          :value           (:test/body @field-editor-state*)
          :editor/type     :editor.type/richtext-mention
          :field/data-type :data.type/text-richtext
          :ui/variable-source :survey-template-text
          :tools           [:tool-item/clear :tool-item/save :tool-item/cancel]
          :error-text      (get @errors* :test/body)
          :validate!       (fn [_attribute _value] nil)
          :on-save!        (fn [attribute value on-success! _on-error!]
                             (swap! field-editor-state* assoc attribute value)
                             (on-success!))}]
        [:pre {:class "rounded bg-base-light p-3 text-xs overflow-auto"}
         (pr-str @field-editor-state*)]]])))

(defn view
  []
  [page/centered
   [:div {:class "flex w-full max-w-5xl flex-col gap-6 py-6"}
    [:div {:class "flex flex-col gap-1"}
     [:h1 {:class "text-2xl font-bold"} "Mention editor tests"]
     [:p {:class "text-sm text-base-light-text-lighter"}
      "Covers both the new labelled input/data-input path and the generic field-editor path used by entity editors."]]
    [labelled-input-demo]
    [field-editor-demo]]])
